/* eslint-disable no-undef */
import React from "react";
import "./styles.css";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { getAuth, signOut } from "firebase/auth";
import MenuIcon from "@mui/icons-material/Menu";
import { Home } from "@mui/icons-material";
import {
  Toolbar,
  AppBar,
  Button,
  IconButton,
  useMediaQuery,
} from "@mui/material";
import LinearLoading from "../LinearLoading/LinearLoading";
import {
  clearAdminState,
  clearAuthState,
  clearTeacherState,
  logoutFail,
  logoutStart,
  logoutSuccess,
  onSignOut,
} from "../../redux/actions";
import Locale from "../../locales/index";

const Navbar = ({ handleDrawerToggle }) => {
  const teacherLoading = useSelector((state) => state.teacherReducer.loading);
  const authLoading = useSelector((state) => state.authReducer.loading);
  const adminLoading = useSelector((state) => state.adminReducer.loading);
  const currentStudentName = useSelector(
    (state) => state.teacherReducer.currentStudentName,
  );
  const currentUser = useSelector((state) => state.authReducer.currentUser);
  const dispatch = useDispatch();
  const isSmall = useMediaQuery("(max-width:1400px)");
  const history = useHistory();

  const logoutClicked = () => {
    dispatch(logoutStart());
    const auth = getAuth();
    signOut(auth)
      .then(() => {
        dispatch(onSignOut());
        dispatch(logoutSuccess());
        dispatch(clearTeacherState());
        dispatch(clearAuthState());
        dispatch(clearAdminState());
      })
      .catch((err) => {
        dispatch(logoutFail(err.message));
      });
  };

  const goHomeClicked = () => {
    history.push("/teacher");
  };

  const HamburgerButton = () =>
    currentStudentName ? (
      <IconButton onClick={handleDrawerToggle} aria-label="hamburger">
        <MenuIcon />
      </IconButton>
    ) : (
      <div />
    );

  return (
    <div
      className={
        currentStudentName ? "student-navbar-container" : "navbar-container"
      }>
      <AppBar color="default" elevation={6} position="static">
        <Toolbar className="navbar-toolbar">
          {isSmall ? (
            <HamburgerButton />
          ) : (
            <div className="navbar-user-heading">
              <h3 className="navbar-heading-text">
                {currentStudentName
                  ? ` ${currentStudentName}'s  ${Locale.t("profile")}`
                  : `${Locale.t("welcome")} ${currentUser}`}
              </h3>
            </div>
          )}

          <div className="button-container">
            <Button
              disabled={teacherLoading || adminLoading || authLoading}
              startIcon={<Home />}
              onClick={goHomeClicked}
              variant="contained"
              color="warning">
              {Locale.t("home")}
            </Button>

            {history.location.pathname === "/teacher" && (
              <Button
                disabled={teacherLoading || adminLoading || authLoading}
                onClick={logoutClicked}
                variant="contained"
                color="error">
                {Locale.t("logout")}
              </Button>
            )}
          </div>
        </Toolbar>
      </AppBar>
      <LinearLoading />
    </div>
  );
};

export default Navbar;
